import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { HttpClient, HttpParams } from '@angular/common/http';
import { equipmentVwMdl, ComponentOverViewVwMdl } from '../../entities/equipment/model';
import { Observable } from 'rxjs/Observable';
import { UserSelectedIds, SearchItem, EquipmentViewResult, SearchItemsParam, ComponentViewResult, RecommendedActionsViewModel, PrintItem, EquipmentShovelData, EquipmentForecastDataVM, FleetModelAverageHours } from '../../entities';
import { Subject } from 'rxjs/Subject';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import { catchError } from 'rxjs/operators';
import { SearchItems } from './components/fleet-view-averages/fleet-view-averages.component';
@Injectable()
export class DashboardService {
    private showExportSubject = new Subject<number>();
    private exportClickedSubject = new Subject<number>();
    private isPrintSubject = new Subject<boolean>();
    private _currentExportStatus = 0;
    private _is_print_version = false;
    constructor(private _http: HttpClient,private _https: Http) {

    }
    private handleError(error: Response) {
        console.error(error);
        return Observable.throw(error.json().error || 'Server error');
    }

    getExportStatus(): Observable<number> {
        return this.showExportSubject.asObservable();
    }

    sendExportStatus(current: number) {
        this._currentExportStatus = current;
        this.showExportSubject.next(current);
    }

    getExportClicked(): Observable<number> {
        return this.exportClickedSubject.asObservable();
    }

    sendExportClicked(current: number) {
        this.exportClickedSubject.next(current);
    }

    getCurrentExportStatus(): number {
        return this._currentExportStatus;
    }

    getIsPrintSubject(): Observable<boolean> {
        return this.isPrintSubject.asObservable();
    }

    sendIsPrint(current: boolean) {
        this._is_print_version = current;
        this.isPrintSubject.next(current);
    }

    getPrintStatus(): boolean {
        return this._is_print_version;
    }


    /**
 * Returns the class suitable for next inspection column in dashboard
 * @param datestr is the date object in the UTC format
 */
    getNextInspectionCSSClass(datestr: string): string {
        var date = new Date(Date.parse(datestr));
        if (!date) return '';
        let _current = new Date();
        let thisweek = new Date();
        let nextweek = new Date();

        let _next = date;
        thisweek.setDate(thisweek.getDate()+7);
        //console.log("_next ",_next, _current)

//TT-6398
        
        //console.log("_next AA",_next, nextweek)
        //console.log("_next BB",_next, thisweek)

        if(_current> _next){
            return ' x-bg'
        }
        else if (_current<= _next && _next <= thisweek) {
            return ' b-bg';
        }
        else{
            return ' a-bg'
        }
       

        // _next.setMonth(date.getMonth() + 1);
        // if (_next > _current) return ' a-bg';
        // _next.setMonth(_next.getMonth() + 2);
        // if (_next > _current) return ' b-bg';
        // _next.setMonth(_next.getMonth() + 3);
        // if (_next > _current) return ' c-bg';
        // return ' x-bg'
    }
    /**
     * Returns the database column name for sort based on the parameter
     * @param header
     */
    getEquipmentSortColumnName(header: string): string {
        switch (header) {
            case 'customer':
                return 'customerName';
            case 'make':
                return 'make';
            case 'lastInspectionDate':
                return 'lastInspectionDateAsDate';
            case 'nextInspection':
                return 'NextInspectionDate';
            case 'site':
                return 'jobsiteName';
            case 'addiunit':
                    return 'addiunit';
            default:
                return header;
        }
    }

    getEquipmentComponentSortColumnName(header: string): string {
        switch (header) {
            case 'Serial':
                return 'Equipment.Serial';
            case 'Unit':
                return 'Equipment.Unit';
            case 'CurrentSMU':
                return 'Equipment.SMU';
            case 'Model':
                return 'Equipment.ModelDesc';
            case 'Site':
                return 'Equipment.SiteName';
            case 'LastInspectionDate':
                return 'LastInspection.Date';
            case 'LastInspectionSMU':
                return 'LastInspection.SMU';
            case 'NextInspectionSMU':
                return 'Equipment.NextInspectionSMU';
            case 'AddiUnit':
                return 'Equipment.AddiUnit';
            case 'Inspector':
                return 'Equipment.inspector';
            case 'DaysSinceLastInspection':
                return 'Equipment.DaysSinceLastInspection';
            default:
                return 'LastInspection.Date';
        }
    }

    public getEquipmentList(PageNo: number, PageSize: number): Observable<equipmentVwMdl[]> {
        let params: HttpParams = new HttpParams();
        params.set('PageNo', PageNo.toString());
        params.set('PageSize', PageSize.toString());
        return this._http.get<equipmentVwMdl[]>("Api/Dashboard/getEquipmentList", { params: params }).pipe(catchError(this.handleError));
    }

    public getEquipmentListByCondition(PageNo: number, PageSize: number, SelectedIds: UserSelectedIds): Observable<equipmentVwMdl[]> {
        let params: HttpParams = new HttpParams();
        params.set('PageNo', PageNo.toString());
        params.set('PageSize', PageSize.toString());
        params.set('CustomerId', SelectedIds.CustomerId.toString());
        params.set('JobSiteId', SelectedIds.JobSiteId.toString());
        params.set('EquipmentId', SelectedIds.EquipmentId.toString());
        params.set('FamilyId', SelectedIds.FamilyId.toString());
        params.set('MakeId', SelectedIds.MakeId.toString());
        params.set('ModelId', SelectedIds.ModelId.toString());
        return this._http.get<equipmentVwMdl[]>("Api/Dashboard/getEquipmentListByCondition", { params: params }).pipe(catchError(this.handleError));
    }

  public getEquipmentViewListBySearchItems(PageNo: number, PageSize: number, SearchItems: SearchItem[], _clientReqId: number, sortColumn: string, ascending: string): Observable<EquipmentViewResult>
  {
        let params: SearchItemsParam = new SearchItemsParam();
        params.PageNo = PageNo;
        params.PageSize = PageSize;
        params.SearchItems = SearchItems;
        params._clientReqId = _clientReqId;
        params.sortName = this.getEquipmentSortColumnName(sortColumn);
        params.ascendingOrder = ascending != "desc";
        return this._http.post<EquipmentViewResult>("Api/Dashboard/getEquipmentViewListBySearchItems", params).pipe(catchError(this.handleError));
    }

    public getEquipmentViewListByPrintId(id: number): Observable<EquipmentViewResult> {
        let params: HttpParams = new HttpParams().set('Id', id.toString());
        return this._http.get<EquipmentViewResult>("Api/Dashboard/getEquipmentViewListByPrintId", { params: params }).pipe(catchError(this.handleError));
    }

    public getComponentViewListBySearchItems(PageNo: number, PageSize: number, SearchItems: SearchItem[], _clientReqId: number, sortColumn: string, ascending: string): Observable<ComponentViewResult> {
        let params: SearchItemsParam = new SearchItemsParam();
        params.PageNo = PageNo;
        params.PageSize = PageSize;
        params.SearchItems = SearchItems;
        params._clientReqId = _clientReqId;
        let _column = this.getEquipmentComponentSortColumnName(sortColumn).split('.');
        params.sortName = _column[1];
        params.memberName = _column[0];
        params.ascendingOrder = ascending != "desc";
        return this._http.post<ComponentViewResult>("Api/Dashboard/getComponentViewListBySearchItems", params).pipe(catchError(this.handleError));
    }

    public getComponentViewListByPrintId(id: number): Observable<ComponentViewResult> {
        let params: HttpParams = new HttpParams().set('Id', id.toString());
        return this._http.get<ComponentViewResult>("Api/Dashboard/getComponentViewListByPrintId", { params: params }).pipe(catchError(this.handleError));
    }

    public getRecommendedActions(Ids: number[]): Observable<RecommendedActionsViewModel[]> {
        let IdsString = "";
        Ids.forEach(m => {
            IdsString += m + ',';
        });
        let params: HttpParams = new HttpParams().set('Ids', IdsString);
        return this._http.post<RecommendedActionsViewModel[]>("Api/Dashboard/getRecommendedActions", { Ids: IdsString }).pipe(catchError(this.handleError));
    }

    public getEquipmentCountByCondition(SelectedIds: UserSelectedIds): Observable<any> {
        let params: HttpParams = new HttpParams();
        params.set('CustomerId', SelectedIds.CustomerId.toString());
        params.set('JobSiteId', SelectedIds.JobSiteId.toString());
        params.set('EquipmentId', SelectedIds.EquipmentId.toString());
        params.set('FamilyId', SelectedIds.FamilyId.toString());
        params.set('MakeId', SelectedIds.MakeId.toString());
        params.set('ModelId', SelectedIds.ModelId.toString());
        return this._http.get("Api/Dashboard/getEquipmentCountByCondition", { params: params }).pipe(catchError(this.handleError));
    }

    public getComponentOverViewList(equipmentId: number): Observable<ComponentOverViewVwMdl[]> {
        let params: HttpParams = new HttpParams();
        params.set('equipmentId', equipmentId.toString());
        return this._http.get<ComponentOverViewVwMdl[]>("Api/Dashboard/getComponentOverview", { params: params }).pipe(catchError(this.handleError));
    }
    public getQuotePDF(quoteId: number, url: string): Observable<any> {
        const body = { quoteId: quoteId.toString() }
        return this._http.post(url, body).pipe(catchError(this.handleError));
    }

    public SaveSearchItemsComponentViewForExport(PageNo: number, PageSize: number, SearchItems: SearchItem[], _clientReqId: number, sortColumn: string, ascending: string): Observable<any> {
        let params: SearchItemsParam = new SearchItemsParam();
        params.PageNo = PageNo;
        params.PageSize = PageSize;
        params.SearchItems = SearchItems;
        params._clientReqId = _clientReqId;
        let _column = this.getEquipmentComponentSortColumnName(sortColumn).split('.');
        params.sortName = _column[1];
        params.memberName = _column[0];
        params.ascendingOrder = ascending != "desc";
        return this._http.post("Api/Dashboard/SaveSearchItemsComponentViewForExport", params).pipe(catchError(this.handleError));
    }

    public UpdatePrintItem(PrintId: number, HtmlText: string, HtmlElement: string): Observable<any> {
        let params: PrintItem = new PrintItem();
        params.PrintId = PrintId;
        params.HtmlText = HtmlText;
        params.HtmlElement = HtmlElement;
        return this._http.post("Api/Dashboard/UpdatePrintItem", params).pipe(catchError(this.handleError));
    }

    public SaveSearchItemsFleetViewForExport(PageNo: number, PageSize: number, SearchItems: SearchItem[], _clientReqId: number, sortColumn: string, ascending: string): Observable<any> {
        let params: SearchItemsParam = new SearchItemsParam();
        params.PageNo = PageNo;
        params.PageSize = PageSize;
        params.SearchItems = SearchItems;
        params._clientReqId = _clientReqId;
        params.sortName = this.getEquipmentSortColumnName(sortColumn);
        params.ascendingOrder = ascending != "desc";
        return this._http.post("Api/Dashboard/SaveSearchItemsFleetViewForExport", params).pipe(catchError(this.handleError));
    }

    public getDashboardShovelView(PageNo: number, PageSize: number, SearchItems: SearchItem[], _clientReqId: number, sortColumn: string, ascending: string): Observable<EquipmentForecastDataVM> {
        let params: SearchItemsParam = new SearchItemsParam();
        params.PageNo = PageNo;
        params.PageSize = PageSize;
        params.SearchItems = SearchItems;
        params._clientReqId = _clientReqId;
        let _column = this.getEquipmentComponentSortColumnName(sortColumn).split('.');
        params.sortName = _column[1];
        params.memberName = _column[0];
        params.ascendingOrder = ascending != "desc";
        return this._http.post<EquipmentForecastDataVM>("Api/Dashboard/getDashboardShovelView", params).pipe(catchError(this.handleError));
  }

  fleetModelAverageHours(data: SearchItems): Observable<FleetModelAverageHours[]> {
    return this._http.post<FleetModelAverageHours[]>(
      "Api/Dashboard/FleetModelAverageHours",
      data
    );
  }

  adjustfleetModelAverageHours(data: FleetModelAverageHours): Observable<boolean> {
    return this._http.post<boolean>(
      "Api/Dashboard/AdjustFleetModelAverageHours",
      data
    );
  }


}
